import React, { useEffect, useMemo, useState } from 'react';
import { useUserStore } from "../../../hooks/admin/user";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { AgGridReact } from 'ag-grid-react';
import useReduxState from 'src/hooks/useReduxState';
import NoResultContent from '../../HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';
import Admin from '@system/config/admin';
import { useAdminCommonStore } from 'src/hooks/admin/adminCommon';
import { Tooltip } from 'src/component/Global/Tooltip';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';


let roleData = [];
let isEditGlobal = false;
let userDetailGlobal = {};
export function UserSponsorAcctList(props) {
  const [__check] = useAxiosIndicatorCheck();
  const [{
    userDetail,
    userAcctList,
    totalUserRecords,
    selectedRoles
  }, { get_user_acct_list }, {
    set_role_selection_popup_status,
    set_select_user_sponsor_accounts,
    update_user_roles
  }] = useUserStore();
  const [selectionCount, setSelectionCount] = useState(0);
  const [refreshGrid, setRefreshGrid] = useReduxState(true, 'setRefreshGrid');
  const [isEdit] = useReduxState(false, 'setIsEdit');
  const [rowData, setRowData] = useState([]);
  const gridRef = React.useRef();
  const userId = props.userId;
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [agGridFiltered, setAgGridFiltered] = useState(0);
  const [{ roleList }] = useAdminCommonStore();
  const [selectedIndex, setIndex] = useState(-1);
  const [isSponsorRoleSelect] = useReduxState(false, 'setIsSponsorRoleSelect');
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

  const addRole = (e) => {
    let data;
    if (e.data) {
      data = e.data;
    } else if (e.node.field === 'Role') {
      data = e.node.allLeafChildren[0]?.data;
    } else return "";
    const role = data.Role;
    let renderedRole = Helper.renderRoles(role, roleData);
    const cellContent = data.Source === "SAP" || isEditGlobal ? <span className={'text-black-stone'}>{role.length > 0 ? renderedRole : 'Select a Role (required)'}</span> :

      <a className={'text-blue2'} onClick={() => {
        openPopup(e.data, e.rowIndex)
      }}><u>
          {role.length > 0 ? renderedRole : 'Select a Role (required)'}
      </u>
      </a>

    return role.length > 0 ? <Tooltip
      arrow={false}
      position={'top left'}
      opener={() => cellContent}
      content={() => `${renderedRole}`}
    /> : cellContent;
  }

  useEffect(() => {
    userDetailGlobal = userDetail;
  }, [userDetail]);

  const roleSortingAgGrid = (roleA, roleB) => {
    const renderedRoleA = Helper.renderRoles(roleA, roleData);
    const renderedRoleB = Helper.renderRoles(roleB, roleData);
    return renderedRoleA.localeCompare(renderedRoleB);
  }
  const openPopup = (account, rowIndex) => {
    setIndex(rowIndex)
    set_select_user_sponsor_accounts({ account, userData: { userName: userDetailGlobal.firstName + " " + userDetailGlobal.lastName } })
    set_role_selection_popup_status(true);
  };

  useEffect(() => {
    isEditGlobal = isEdit;
    setRowData([...rowData])
  }, [isEdit]);

  useEffect(() => {
    if (selectedIndex < 0 || isSponsorRoleSelect) {
      return;
    }
    const params = {
      accountNumber: userAcctList[selectedIndex].accountNumber,
      speedboat: System.avUserInfoData.speedBoatAbbr,
      salesOrg: userAcctList[selectedIndex].salesOrg,
      userId: userAcctList[selectedIndex].userId,
      roles: selectedRoles.map(v => v.roleName),
    }

    async function fetchHere() {
      const res = await update_user_roles(params);
      if (res.isSuccessFull) {
        system_alert_indicator({
          name: "adminconsole",
          message: res.data,
          type: "success",
          isDisplay: true,
        });
        setRefreshGrid(true);
      } else {
        system_alert_indicator({
          name: "adminconsole",
          message: res.message || res.errorMessage || "Error updating user roles",
          type: "danger",
          isDisplayIcon: true,
          isDisplay: false
        });
      }
    }

    fetchHere();
    setIndex(-1)
  }, [selectedRoles]);
  useEffect(() => {
    roleData = roleList;
  }, [roleList])

  useEffect(() => {
    async function fetchHere() {
      await fetchAPICall();
    }
    fetchHere();
  }, []);

  useEffect(() => {
    async function fetchHere() {
      setSelectionCount(0);
      await fetchAPICall();
      setRefreshGrid(false);
    }

    if (refreshGrid) {
      fetchHere();
    }
  }, [refreshGrid]);

  const loadAccountNumber = (e) => {
    const data = e?.data ? e?.data : e.node.allLeafChildren[0]?.data;
    return <>
      <a
        href={Admin.getAccountDetailURL() + '?accountNumber=' + data?.AccountNumber + '&salesOrg=' + data?.SalesOrg + '&speedboat=' + System.avUserInfoData.speedBoatAbbr}
        className='' target="_blank" rel="noreferrer"> {e?.value}</a>
    </>
  }

  useEffect(() => {
    const data = userAcctList?.map((ele, idx) => {
      return {
        AccountNumber: ele.accountNumber,
        AccountName: ele.accountName,
        Role: ele.roles ? ele.roles.split(',').map(v => v.trim()) : [],
        SalesOrg: ele.salesOrg,
        Currency: ele.currency,
        OrderBlock: ele.orderBlock === true ? 'Yes' : ele.orderBlock === false ? 'No' : '',
        BillToCountry: ele.billToCountryCode,
        Description: ele.description,
        CreditRisk: ele.creditRisk === true ? 'Yes' : ele.creditRisk === false ? 'No' : '',
        PaymentTermID: ele.paymentTermId,
        Active: ele.active ? 'Active' : 'Inactive',
        CreatedOn: ele.createdDate ? Helper.getDatepickerFormatAdminConsole(ele.createdDate) : "",
        UpdatedOn: ele.updatedDate ? Helper.getDatepickerFormatAdminConsole(ele.updatedDate) : ""
      }
    });
    setRowData(data)
  }, [userAcctList]);


  const fetchAPICall = async () => {
    __set('USER_ACCOUNT_API_CALL')
    const res = await get_user_acct_list(userId)
    if (res?.payload?.Message) {
      system_alert_indicator({
          name: "accessDenied",
          message: data?.payload?.Message,
          type: "danger",
          isDisplayIcon: true,
          isDisplay: false
      });
  }
    __remove('USER_ACCOUNT_API_CALL')
  };

  const [columnDefs] = useState([
    {
      field: '', pinned: 'left', lockPosition: "left",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,
      width: 50,
      enableFilter: false,
      unSortIcon: true,
    },
    {
      field: 'AccountNumber', pinned: 'left', minWidth: 150, lockPosition: "left",
      width: 50,
      enableFilter: false,
      suppressMovable: true,
      headerName: 'ACCOUNT NUMBER',
      headerTooltip: 'ACCOUNT NUMBER',
      sortable: true, comparator: Helper.textSortingAgGrid,
      cellRenderer: loadAccountNumber,
      unSortIcon: true,
    },
    {
      field: 'AccountName', pinned: 'left', minWidth: 200, suppressMovable: true, lockPosition: "left",
      headerName: 'ACCOUNT NAME',
      headerTooltip: 'ACCOUNT NAME',
      sortable: true, comparator: Helper.textSortingAgGrid,
      unSortIcon: true,
    },

    {
      field: 'Role',
      pinned: 'left',
      headerName: 'ROLE',
      lockPosition: "left",
      headerTooltip: 'ROLE',
      sortable: true,
      comparator: roleSortingAgGrid,
      cellRenderer: addRole,
      unSortIcon: true,
    },
    {
      field: 'SalesOrg',
      minWidth: 130,
      headerName: 'SALES ORG COUNTRY',
      headerTooltip: 'SALES ORG COUNTRY',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      unSortIcon: true,
    },
    {
      field: 'Currency',
      minWidth: 130,
      headerName: 'CURRENCY',
      headerTooltip: 'CURRENCY',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      unSortIcon: true,
    },
    {
      field: 'OrderBlock',
      minWidth: 130,
      headerName: 'ORDER BLOCK',
      headerTooltip: 'ORDER BLOCK',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      unSortIcon: true,
    },
    {
      field: 'BillToCountry',
      minWidth: 130,
      headerName: 'BILL TO COUNTRY CODE',
      headerTooltip: 'BILL TO COUNTRY CODE',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      unSortIcon: true,
    },
    {
      field: 'Description',
      minWidth: 130,
      headerName: 'DESCRIPTION',
      headerTooltip: 'DESCRIPTION',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      unSortIcon: true,
    },

    {
      field: 'PaymentTermID',
      minWidth: 130,
      headerName: 'PAYMENT TERM ID',
      headerTooltip: 'PAYMENT TERM ID',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      unSortIcon: true,
    },
    {
      field: 'Active',
      minWidth: 130,
      headerName: 'STATUS',
      headerTooltip: 'STATUS',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      unSortIcon: true,
    },
    {
      field: 'CreatedOn',
      minWidth: 180, headerName: 'CREATED ON',
      headerTooltip: 'CREATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      },
      unSortIcon: true,
    },
    {
      field: 'UpdatedOn',
      minWidth: 180,
      headerName: 'UPDATED ON',
      headerTooltip: 'UPDATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      },
      unSortIcon: true,
    }

  ]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      width: 150,
      resizable: true
    };
  }, []);

  const onSelectionChanged = () => {
    setSelectionCount(gridRef?.current?.api?.getSelectedRows().length);
  }

  const exportGrid = async () => {
    if (isEdit)
      return false;

    const allColumnState = gridColumnApi.getColumnState();
    const customColumns = allColumnState.map((column) => column.colId);

    const params = { fileName: `user_detail.xlsx`, sheetName: "user", columnKeys: customColumns.slice(1) };

    await gridRef.current.api.exportDataAsExcel(params);

    system_alert_indicator({
      name: "adminconsole",
      message: Constants.downloadMsg,
      type: "success",
      isDisplay: true,
    });

  }

  const onUnsponsorAcct = () => {
    if (gridRef.current.api.getSelectedRows().length > 0) {
      const list = gridRef.current.api.getSelectedRows();
      System.popup('UnsponsorUserAcct', { userId, list, base: 'userDetails' })
    }
  }


  const isRowSelectable = (node) => {
    const rowData = node.data;
    return !isEditGlobal && !!(rowData && userDetail.source !== 'SAP');
  };

  const gridUpdateCallback = (event) => {
    setAgGridFiltered(event.api.getDisplayedRowCount());
  }
  const onColumnResided = (event) => {
    event.columnApi.getColumn('0').setActualWidth(50);
  }

  const onGridReady = (params) => {
    setAgGridFiltered(params.api.getDisplayedRowCount());
    params.api.addEventListener('filterChanged', gridUpdateCallback)
    params.api.addEventListener('filterModified', gridUpdateCallback)
    params.api.addEventListener('columnResized', onColumnResided);
    setGridColumnApi(params.columnApi);
  };

  return (
    <>
      {__check(['USER_DETAIL_API_CALL', 'USER_ACCOUNT_API_CALL']).render}
      {!__check(['USER_DETAIL_API_CALL', 'USER_ACCOUNT_API_CALL']).status &&
        <>
          <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
            <div className="d-flex justify-content-start">
              Filtered Line Count: <b>{agGridFiltered}</b>
            </div>
            <div className="d-flex justify-content-end">
              Total Records: <b>{totalUserRecords}</b>
            </div>
          </div>
          <div className='bg-black p-2 px-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <button disabled={isEdit} className={`bs5 btn btn-secondary ${selectionCount > 0 ? '' : ' disabled'}`}
                        onClick={() => onUnsponsorAcct()}><i className="fas5 fa-user-minus text-darkgreen me-2"
                                                             aria-hidden="true"></i>UNSPONSOR FROM AN ACCOUNT
                </button>
              </div>
              <div>
                {/* <button className="bs5 btn btn-secondary me-3" onClick={() => onSave()}><i className="fas5 fa-user-plus text-darkgreen me-2" aria-hidden="true"></i>Save</button> */}
                <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className={`text-white ${isEdit && 'cursor-default'}`}
                  onClick={exportGrid}>
                  <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
                </a>
              </div>
            </div>
          </div>
          {rowData.length > 0 ?
            <div className="ag-theme-alpine ag-grd-hg mb-5">
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowSelection={'multiple'}
                suppressRowClickSelection={true}
                onSelectionChanged={onSelectionChanged}
                isRowSelectable={isRowSelectable}
                onGridReady={onGridReady}
                autoGroupColumnDef={{
                  headerName: 'Group',
                  minWidth: 220,
                }}
              >
              </AgGridReact>
            </div>
            :
            <div>
              <NoResultContent message={'No sponsored account found'} isDisplay={false}/>
            </div>
          }
        </>
      }

    </>);
}
